import { resetToastDefaultOptions, resetDialogDefaultOptions } from 'vant'

/** 使用强制横屏旋转壳的路由（首页已统一 index.vue 竖屏自适应，不再走旋转壳） */
const PHONE_ROUTE_NAMES = new Set([
  'PosterPhone'
])

function pathUsesPhoneRotate(path) {
  const p = (path || '').toLowerCase()
  return p.includes('poster-phone')
}

let overlayModeEnabled = null

/** 当前路由是否使用手机强制横屏旋转壳 */
export function isPhoneRotateRoute(route) {
  if (!route) return false
  if (route.name && PHONE_ROUTE_NAMES.has(route.name)) return true
  return pathUsesPhoneRotate(route.path)
}

/**
 * 手机旋转壳：Toast/Dialog 仍挂 body（避免挂进 transform 容器导致卡顿、闪烁），
 * 通过 html.phone-rotate-active + CSS 与页面同向旋转。
 */
export function syncVantOverlayTeleport(route) {
  if (typeof document === 'undefined') return

  const enabled = isPhoneRotateRoute(route)
  if (overlayModeEnabled === enabled) return
  overlayModeEnabled = enabled

  if (enabled) {
    document.documentElement.classList.add('phone-rotate-active')
  } else {
    document.documentElement.classList.remove('phone-rotate-active')
    resetToastDefaultOptions()
    resetDialogDefaultOptions()
  }
}
